'use strict';

import controller from './user.controller';
import template from './user.html';

const UserComponent = {
    bindings: {},
    controller,
    template
};

export default UserComponent;


// WEBPACK FOOTER //
// ./src/app/components/admin/user/user.component.js